import type React from "react";
import { useState } from "react";
import { translate } from "app/filters/i18nFilter";
import { EmptyStateContainer } from "app/pages/digital-suite/home-page/components/CustomAssets/Containers/EmptyStateContainer/EmptyStateContainer";
import type { IEmptyStateProps } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import { AssetName } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import {
    navigateToKeywordAnalysisOverview,
    navigateToKeywordGenerator,
} from "app/pages/digital-suite/home-page/components/CustomAssets/customAssetsUtils";
import {
    TextContainer,
    Text,
} from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/PredefinedTemplate/styledComponents";
import { KeywordsGroupEditorModal } from "app/pages/keyword-analysis/KeywordsGroupEditorModal";
import { BasicDurations } from "app/services/DurationService";

export const KeywordListEmptyState: React.FC<IEmptyStateProps> = ({ marginBottom }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <EmptyStateContainer
                type={AssetName.KeywordLists}
                marginBottom={marginBottom}
                title={translate("digitalmarketing.homepage.custom_assets.empty_state.keywordList.title")}
                subtitle={translate("digitalmarketing.homepage.custom_assets.empty_state.keywordList.subtitle")}
                columns={2}
                assets={[
                    {
                        title: translate(
                            "digitalmarketing.homepage.custom_assets.empty_state.keywordList.templates.daily_traffic.title",
                        ),
                        content: (
                            <TextContainer isDisplayed>
                                <Text>
                                    {translate(
                                        "digitalmarketing.homepage.custom_assets.empty_state.keywordList.templates.daily_traffic.text",
                                    )}
                                </Text>
                            </TextContainer>
                        ),
                        buttonText: translate(
                            "digitalmarketing.homepage.custom_assets.empty_state.keywordList.templates.daily_traffic.button",
                        ),
                        onClick: () => setIsModalOpen(true),
                    },
                    {
                        title: translate(
                            "digitalmarketing.homepage.custom_assets.empty_state.keywordList.templates.keywords.title",
                        ),
                        content: (
                            <TextContainer isDisplayed>
                                <Text>
                                    {translate(
                                        "digitalmarketing.homepage.custom_assets.empty_state.keywordList.templates.keywords.text",
                                    )}
                                </Text>
                            </TextContainer>
                        ),
                        buttonText: translate(
                            "digitalmarketing.homepage.custom_assets.empty_state.keywordList.templates.keywords.button",
                        ),
                        onClick: () =>
                            navigateToKeywordGenerator({
                                country: "999",
                                duration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
                            }),
                    },
                ]}
            />
            <KeywordsGroupEditorModal
                onClose={() => setIsModalOpen(false)}
                open={isModalOpen}
                onSave={({ Id: keywordListId }) => navigateToKeywordAnalysisOverview(keywordListId)}
                showGoToMonitorKeywordListButton
            />
        </>
    );
};
